import React from "react";

export const TimeBoardIcon = ({ isActive, ...props }: SvgIconProps) => {
  return (
    <svg width={14} height={14} viewBox="0 0 14 14" fill="none" {...props}>
      <path
        d="M7 13A6 6 0 107 1a6 6 0 000 12z"
        stroke={isActive ? "#ffff" : "#214160"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 3.4V7l2.4 1.2"
        stroke={isActive ? "#ffff" : "#214160"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
